import React from "react";

const ContactAndHelp = () => {
  return (
    <div className="globalmainstyles">
      <h1>Help</h1>
      <p>
        If you need help or have any issues with our app, please reach out to
        us:
      </p>
      <p>Email: richpong123@gmail.com</p>
      <p>Phone: +233 50 892 2801</p>
    </div>
  );
};

export default ContactAndHelp;
